import { CardNotice } from '@euler/app/flows/ai-suite/components/ChatCard';
import { parseBiVisualizationWidgetPayload } from '@euler/model/bi/widgets';
import { memo } from 'react';
import { BiDraftCard } from './BiDraftCard';

/**
 * The `bi_visualization` fence: the chart, table or KPI of the draft it
 * names. The fence carries the id only; every number comes from the draft's
 * snapshot, so history replays what the reply showed then.
 */
export const BiVisualizationWidget = memo(({ data }: { data: unknown }) => {
  const ref = parseBiVisualizationWidgetPayload(data);
  if (!ref) return <CardNotice text="这张图表的引用无效，请重新提问生成。" />;
  return (
    <BiDraftCard key={ref.draftId} draftId={ref.draftId} title={ref.title} />
  );
});
